// extracted by mini-css-extract-plugin
export var dataCell = "_ra-2";
export var dataRow = "_ra-0";
export var headerRow = "_ra-1";